import z from "zod";

/**
 * CopyInspecaoMaquinaEquipSchema
 */

export const CopyInspecaoMaquinaEquipSchema = z.object({
  nroCopias: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).min(1, 'O número de cópias deve ser maior que zero'),
});

/**
 * CopyInspecaoMaquinaEquipForm
 */

export type CopyInspecaoMaquinaEquipForm = z.infer<typeof CopyInspecaoMaquinaEquipSchema>;